/* G Dash (#obcount): Shrine's own countdowns, the cart drawer's "Cart reserved for [timer]" and the sign-up popup's
   timer, are each visitor's own. The start is kept in the visitor's browser, so a reload or a new tab carries on where it
   was; at zero it starts again from its full length (the block's or the section's setting) and keeps looping. Shrine's files
   are not changed: once each element is defined, its timer methods are replaced and the timers already on the page are set
   right. The cart's starts the first time the cart shows it, the popup's the first time the popup shows it. */
(function () {
  'use strict';
  if (window.__gdCountdown || !window.customElements || !customElements.whenDefined) return;
  window.__gdCountdown = true;
  var mem = {};
  function two(n) { return n < 10 ? '0' + n : String(n); }
  function startOf(key, make) {
    var s = 0, now = Date.now();
    try { s = parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!s) s = mem[key] || 0;
    if (s > now) s = 0;
    if (!s && make) {
      s = now;
      try { window.localStorage.setItem(key, String(s)); } catch (e) {}
    }
    if (s) mem[key] = s;
    return s;
  }
  function left(key, len, make) {
    if (!(len > 0)) return 0;
    var s = startOf(key, make);
    return s ? len - Math.floor(((Date.now() - s) % (len * 1000)) / 1000) : len;
  }
  function loop(el, key) {
    clearTimeout(el.__gdT);
    var tick = function () {
      if (!el.isConnected) { el.__gdT = 0; return; }
      el.updateTimer();
      el.__gdT = setTimeout(tick, 1000 - ((Date.now() - (startOf(key, false) || 0)) % 1000) + 5);
    };
    tick();
  }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }
  customElements.whenDefined('countdown-timer').then(function () {
    var C = customElements.get('countdown-timer'), P = C && C.prototype;
    if (!P || P.__gdCd) return;
    P.__gdCd = true;
    P.gdLen = function () { var n = parseInt(this.duration, 10); return n > 0 ? n : 0; };
    P.gdKey = function () { return 'gd-cd:cart:' + this.gdLen(); };
    P.updateTimer = function () {
      var s = left(this.gdKey(), this.gdLen(), false);
      if (this.minutesSpan) this.minutesSpan.innerHTML = two(Math.floor(s / 60));
      if (this.secondsSpan) this.secondsSpan.innerHTML = two(s % 60);
    };
    P.playTimer = function () {
      clearInterval(this.playInterval);
      this.isPlaying = true;
      startOf(this.gdKey(), true);
      loop(this, this.gdKey());
    };
    P.pauseTimer = function () {
      clearInterval(this.playInterval);
      clearTimeout(this.__gdT);
      this.__gdT = 0;
      this.isPlaying = false;
    };
    each('countdown-timer', function (el) { if (el.minutesSpan) { if (el.isPlaying) el.playTimer(); else el.updateTimer(); } });
  });
  customElements.whenDefined('promo-popup').then(function () {
    var C = customElements.get('promo-popup'), P = C && C.prototype;
    if (!P || P.__gdCd) return;
    P.__gdCd = true;
    P.gdLen = function () { var m = parseFloat(this.timerDuration); return m > 0 ? Math.round(m * 60) : 0; };
    P.gdKey = function () { return 'gd-cd:popup:' + this.gdLen(); };
    P.updateTimer = function () {
      var s = left(this.gdKey(), this.gdLen(), true);
      if (this.minutesSpan) this.minutesSpan.innerText = two(Math.floor(s / 60));
      if (this.secondsSpan) this.secondsSpan.innerText = two(s % 60);
    };
    P.displayPromoTimer = function () {
      this.minutesSpan = this.querySelector('.popup-modal__timer__minutes');
      this.secondsSpan = this.querySelector('.popup-modal__timer__seconds');
      startOf(this.gdKey(), true);
      loop(this, this.gdKey());
    };
    each('promo-popup', function (el) { if (el.minutesSpan) el.displayPromoTimer(); });
  });
})();
